import React, {useState, useEffect} from 'react';
import BeneficiariesError from '../beneficiaries-error';
import { MasterDataGrid } from "@/components/";
import { Toast } from "devextreme-react/toast";
import styles from './index.module.scss';

export interface IByOverlapsProps{    
	presenter: any;
	auxCol: any;
	status: any;
	screen: any;
	data: any;
	tableAlert: string;
	saveTable(instance: any): void;
    isTourSeen: boolean;
}

const OverlapDetail = ({tableAlert, saveTable, status, presenter, auxCol, data, screen, isTourSeen}: IByOverlapsProps) => {
    const [auxData, setAuxData] = useState<any>(null);
    const [toastConfig, setToastConfig] = React.useState({
		isVisible: false,
		type: null,
		parent: null,
        child: null
	});

    const onHidingToast = () => {
        setToastConfig({
			...toastConfig,
			isVisible: false,
		});
	};

    useEffect(() => {
        if(!tableAlert || tableAlert === "All" || tableAlert?.includes("beneficiaries-by-overlap-detail")){
            let auxAlert = (tableAlert === "All" || tableAlert?.includes("beneficiaries-by-overlap-detail")) ? "All" : tableAlert
            setAuxData(
                <>
                    {isTourSeen &&
                        <BeneficiariesError 
                            followupLabels={presenter.followupLabels}
                            tableAlert={auxAlert}
                            gridId={`beneficiaries-by-overlap-detail-${data.data.id}`} 
                            calculatedReqFields={(item: any) => presenter.checkReqFields(item, status)} 
                            calculatedBenPlan={(item: any) => presenter.checkBenPlan(item, status?.CodigoDimension)} 
                        />
                    }
                    <MasterDataGrid 
                        id={`beneficiaries-by-overlap-detail-${data.data.id}`}
                        dataSource={data.data.overlaps || []}
                        columns={auxCol?.colOver}
                        allowCode={screen}
                        gridHelpId={`tooltip-byoverlap-detail-${data.data.id}`}
                        gridHelpText={presenter.followupLabels.get("helpBeneficiariesByOverlapDetail")}
                        saveTable={saveTable}
                        gridProps={{
                            scrolling: { mode: "standard", useNative: false, showScrollbar: 'never'},
                            editing:{ mode:"batch", allowUpdating:true, allowAdding: false, allowDeleting: false},
                            rowAlternationEnabled:false,
                            onFocusedCellChanged: (e) => {
                                if(!!e?.row?.data?.parentResult && !!e?.row?.data?.parentResult){
                                    setToastConfig({
                                        isVisible: true,
                                        type: 'info',
                                        parent: e?.row?.data?.parentResult,
                                        child: e?.row?.data?.result
                                    })
                                }
                            },
                        }}            
                    />
                </>
            )
        }
        
    }, [data?.data, tableAlert, status?.CodigoDimension, auxCol?.colOver, screen, isTourSeen]); 

    const renderContent = () => {
        return (
            <div className={styles.toast}>
                <h6>
                    {presenter.followupLabels.get("toastParent")} {toastConfig.parent}
                </h6>
                <h6>
                    {presenter.followupLabels.get("toastChild")} {toastConfig.child}
                </h6>
            </div>
        );
    }
    return (
        <>
            {auxData}
            {toastConfig.isVisible &&
                <Toast
                    visible={toastConfig.isVisible}
                    contentRender={renderContent}
                    type={'custom'}
                    onHidden={onHidingToast}
                    closeOnOutsideClick={true}
                    displayTime={1000000}
                />
            }
        </>
    )
}

export default OverlapDetail